import { DateTime } from "luxon";

export type TimeGranularity = "day" | "week" | "month"; // if we add a "today" view, add "hour"

//
export interface TimePeriod {
  granularity: TimeGranularity;
  start: DateTime;
  end: DateTime;
}

/**
 * Given a time range (start to end), break it up in `n` periods according
 * to the specified granularity.
 *
 * For example, given a time range that is ~1yr long:
 *  - if granularity = "day", should break up into ~365 days
 *  - if granularity = "week", should break up into ~52 weeks
 *  - if granularity = "month", should break up into 12 months
 */
export const convertDateRangeToTimePeriods = (
  granularity: TimeGranularity,
  // e.g.
  rangeStart: DateTime,
  rangeEnd: DateTime,
): TimePeriod[] => {
  const periods: TimePeriod[] = [];
  // Convert to UTC and normalize to start of day
  let currentStart = rangeStart.toUTC().startOf(granularity);
  const end = rangeEnd.toUTC().startOf(granularity);

  while (currentStart <= end) {
    const periodEnd = currentStart.endOf(granularity);
    periods.push({
      granularity,
      start: currentStart,
      end: periodEnd,
    });
    currentStart = currentStart.plus({ [`${granularity}s`]: 1 });
  }

  return periods;
};
